import * as React from 'react';
const { useCallback, useState, forwardRef } = React;

import { formatStrAsMoney } from '../../utils/money';
import NumberTextFiled, { NumberTextFieldProps } from '../number-text-field';


export type MoneyTextFieldProps = {} & NumberTextFieldProps;

const MoneyTextField: React.SFC<MoneyTextFieldProps> = forwardRef<any, MoneyTextFieldProps>((props, ref) => {
	const {
		value,
		precision,
		onChange,
		...rest
	} = props;
	const [isFocused, setIsFocused] = useState<boolean>(false);
	const handleFocus = useCallback(() => setIsFocused(true), []);
	const handleBlur = useCallback(() => setIsFocused(false), []);
	
	return (
		<NumberTextFiled
			{...rest}
			ref={ref}
			value={
				isFocused
					? value
					: formatStrAsMoney({
							value: value.toString(),
							precision,
						})
			}
			precision={precision}
			onChange={onChange}
			onFocus={handleFocus}
			onBlur={handleBlur}
		/>
	);
});

MoneyTextField.displayName = 'MoneyTextField';
MoneyTextField.defaultProps = {
	precision: 2,
};

export default MoneyTextField;
